import { useQuery } from 'react-query';
import { api } from '../../../static/api';
import { ApiGameListItem } from '../../../types/ApiTypes';
import { QueryAliases } from '../../../types/QueryAliases';
import { transformGameListItem } from '../../../utils/api/dataTransformers/transformGame/transformGameListItem';
import useAxiosInstance from '../../axios/useAxiosInstance';

const useActiveGames = () => {
  const axiosInstance = useAxiosInstance();

  const { data, refetch, isSuccess, isLoading, isError } = useQuery(
    [QueryAliases.ACTIVE_GAMES],
    () => axiosInstance.get(api.endpoints.ACTIVE_GAMES),
    {
      cacheTime: 1,
    },
  );

  const apiGames: ApiGameListItem[] | undefined = data?.data;

  const games = !!apiGames ? apiGames.map(game => transformGameListItem(game)) : undefined;

  return {
    games,
    refetch,
    isSuccess,
    isLoading,
    isError,
  };
};

export default useActiveGames;
